import { render, staticRenderFns } from "./ConfiguracionComponent.vue?vue&type=template&id=427128eb&scoped=true&"
import script from "./ConfiguracionComponent.vue?vue&type=script&lang=ts&"
export * from "./ConfiguracionComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguracionComponent.vue?vue&type=style&index=0&id=427128eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427128eb",
  null
  
)

export default component.exports